/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Collections_Meta_DescriptionInputs */

const id_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.title} dari Epic Games Store.`)
};

const ms_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lihat ${i?.title} dari Epic Games Store.`)
};

const da_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se ${i?.title} fra Epic Games Store.`)
};

const de_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entdecken Sie die ${i?.title} im Epic Games Store.`)
};

const en_us2_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Check out the ${i?.title} from the Epic Games Store.`)
};

const es_es2_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre la ${i?.title} de la Epic Games Store.`)
};

const es_mx2_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descubre ${i?.title} de la Epic Games Store.`)
};

const fil_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tingnan ang ${i?.title} mula sa Epic Games Store.`)
};

const fr_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Découvrez ${i?.title} sur l'Epic Games Store.`)
};

const it_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scopri ${i?.title} dall'Epic Games Store.`)
};

const hu_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nézd meg a ${i?.title} gyűjteményt az Epic Games Store-ból.`)
};

const nl_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bekijk ${i?.title} van de Epic Games Store.`)
};

const no_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sjekk ut ${i?.title} fra Epic Games Store.`)
};

const pl_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sprawdź ${i?.title} z Epic Games Store.`)
};

const pt_br2_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Confira o ${i?.title} do Epic Games Store.`)
};

const pt_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Consulte a ${i?.title} da Epic Games Store.`)
};

const ro_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vezi ${i?.title} din Epic Games Store.`)
};

const fi_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutustu ${i?.title} Epic Games Storesta.`)
};

const sv_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kolla in ${i?.title} från Epic Games Store.`)
};

const vi_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xem ${i?.title} từ Epic Games Store.`)
};

const tr_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store'daki ${i?.title} inceleyin.`)
};

const cs_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Podívejte se na ${i?.title} z Epic Games Store.`)
};

const bg_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Вижте ${i?.title} от Epic Games Store.`)
};

const ru_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посмотрите ${i?.title} в Epic Games Store.`)
};

const uk_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Перегляньте ${i?.title} з Epic Games Store.`)
};

const ar_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تصفح ${i?.title} من Epic Games Store.`)
};

const hi_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store से ${i?.title} देखें।`)
};

const th_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ดู ${i?.title} จาก Epic Games Store`)
};

const ja_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store の ${i?.title} をチェック。`)
};

const zh_cn2_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`查看来自Epic游戏商城的 ${i?.title}。`)
};

const zh_hant1_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`檢視來自Epic遊戲商城的 ${i?.title}。`)
};

const ko_collections_meta_description = /** @type {(inputs: Collections_Meta_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Epic Games Store의 ${i?.title}을(를) 확인하세요.`)
};

/**
* | output |
* | --- |
* | "Check out the {title} from the Epic Games Store." |
*
* @param {Collections_Meta_DescriptionInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const collections_meta_description = /** @type {((inputs: Collections_Meta_DescriptionInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Collections_Meta_DescriptionInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_collections_meta_description(inputs)
	if (locale === "ms") return ms_collections_meta_description(inputs)
	if (locale === "da") return da_collections_meta_description(inputs)
	if (locale === "de") return de_collections_meta_description(inputs)
	if (locale === "en-US") return en_us2_collections_meta_description(inputs)
	if (locale === "es-ES") return es_es2_collections_meta_description(inputs)
	if (locale === "es-MX") return es_mx2_collections_meta_description(inputs)
	if (locale === "fil") return fil_collections_meta_description(inputs)
	if (locale === "fr") return fr_collections_meta_description(inputs)
	if (locale === "it") return it_collections_meta_description(inputs)
	if (locale === "hu") return hu_collections_meta_description(inputs)
	if (locale === "nl") return nl_collections_meta_description(inputs)
	if (locale === "no") return no_collections_meta_description(inputs)
	if (locale === "pl") return pl_collections_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_collections_meta_description(inputs)
	if (locale === "pt") return pt_collections_meta_description(inputs)
	if (locale === "ro") return ro_collections_meta_description(inputs)
	if (locale === "fi") return fi_collections_meta_description(inputs)
	if (locale === "sv") return sv_collections_meta_description(inputs)
	if (locale === "vi") return vi_collections_meta_description(inputs)
	if (locale === "tr") return tr_collections_meta_description(inputs)
	if (locale === "cs") return cs_collections_meta_description(inputs)
	if (locale === "bg") return bg_collections_meta_description(inputs)
	if (locale === "ru") return ru_collections_meta_description(inputs)
	if (locale === "uk") return uk_collections_meta_description(inputs)
	if (locale === "ar") return ar_collections_meta_description(inputs)
	if (locale === "hi") return hi_collections_meta_description(inputs)
	if (locale === "th") return th_collections_meta_description(inputs)
	if (locale === "ja") return ja_collections_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_collections_meta_description(inputs)
	if (locale === "zh-Hant") return zh_hant1_collections_meta_description(inputs)
	return ko_collections_meta_description(inputs)
});
export { collections_meta_description as "collections.meta.description" }